import { render, staticRenderFns } from "./LoginResponse.vue?vue&type=template&id=4528366d&"
import script from "./LoginResponse.vue?vue&type=script&lang=js&"
export * from "./LoginResponse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports